var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('center',[_c('h3',[_vm._v("电影著作作者词云图")])]),_c('el-scrollbar',[_c('svg',{attrs:{"id":"wordcloud","height":"50vh","width":"100vw"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }